import { ReactNode } from 'react'

type Props = Readonly<{
  title: ReactNode
  children: ReactNode
  actions?: ReactNode
}>

export const HrPageWrapper = ({ title, children, actions }: Props) => {
  return (
    <div className="c-flex c-flex-col c-grow">
      <div className="c-border-b c-border-grey-200 c-m-4 c-mb-0 c-pb-3 c-mt-6">
        <div className="c-flex c-items-center c-gap-4">
          <h1 className="c-text-xl c-font-nexa c-font-semibold c-flex-1">{title}</h1>
          {actions && <div className="c-ml-auto">{actions}</div>}
        </div>
      </div>
      <main className="c-p-4 c-pr-6 c-flex c-flex-col c-flex-1 c-min-h-0">{children}</main>
    </div>
  )
}
